import { useLocation } from "react-router-dom";
import "./CadastroLicencasCliente.css";
import { useEffect, useState } from "react";
import FormClientsLicence from "../FormClientsLicence/FormClientsLicence";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";

const CadastroLicencasClientes = () => {
  const { state } = useLocation();
  const licenca = state;
  const [type, setType] = useState("");

  useEffect(() => {
    if (licenca) {
      setType("edicao");
    } else if (!licenca) {
      setType("cadastro");
    }
  }, [licenca]);

  return (
    <CadastroContainer>
      <FormClientsLicence licenca={licenca} type={type} />
    </CadastroContainer>
  );
};

export default CadastroLicencasClientes;
